<template>
  <div class="main list-view logbooks-list">
    <div class="sub-header with-sort" style="grid-template-columns: 232px 1fr 1fr 1fr; grid-column-gap: 1em;">
      <div>
        <label>Search In</label>
        <select v-model="filters.search_in" @change="filters.search_term = ''">
          <option value="name">Names</option>
          <option value="address">Addresses</option>
          <option value="serial_number">Serial Numbers</option>
          <option value="form_number">Transaction Serial Numbers</option>
        </select>
      </div>
      <div>
        <label>Search For</label>
        <div class="input-with-control">
          <input
            type="search"
            v-model="filters.search_term"
            :placeholder="'Enter ' + (filters.search_in == 'address' ? 'an' : 'a') + ' ' + filters.search_in.replaceAll('_', ' ') + '...'"
            @search="
              filters.page = 1;
              getList();
            "
            @change="
              filters.page = 1;
              getList();
            "
            v-focus
          />
          <div
            class="button action input-go"
            @click="
              filters.page = 1;
              getList();
            "
          >
            <i class="fas fa-search"></i>
          </div>
        </div>
      </div>
      <div class="controls-sortz">
        <label class="left">Sort</label><br>
        <select v-model="filters.sort" @change="toggleFilter('sort')" style="width: 15em;">
          <option value="date_created">Date Created</option>
          <option value="transfer_date">Transfer Date</option>
          <option value="customer_last_name">Customer Last Name</option>
          <option value="transaction_serial_number">
            Transaction Serial Number
          </option>
        </select>
      </div>
      <div class="controls">
        <pagination
          v-if="showPagination"
          :paging="paging"
          @updatePage="goToPage"
        ></pagination>
      </div>
    </div>

    <div class="filters">
      <div v-if="clientFFLNumbers.length > 0">
        <div class="title">FFL Number...</div>
        <select v-model="filters.client_ffl_number_id" @change="clearFilters()">
          <option
            v-for="(clientFFLNumber, index) in clientFFLNumbers"
            :key="index"
            :value="clientFFLNumber.client_ffl_number_id"
          >
            {{ clientFFLNumber.ffl_number }}
          </option>
        </select>
        <div class="divider"></div>
      </div>

      <label>Not Transferred, Retention Required</label>
      <select
        v-model="filters.not_transferred_retention_required"
        @change="checkFilters('not_transferred_retention_required')"
      >
        <option value="include">Include in list</option>
        <option value="exclude">Exclude from list</option>
        <option value="filter">List only</option>
      </select>
      <label>Not Transferred, Retention Not Required</label>
      <select
        v-model="filters.not_transferred_retention_not_required"
        @change="checkFilters('not_transferred_retention_not_required')"
      >
        <option value="include">Include in list</option>
        <option value="exclude">Exclude from list</option>
        <option value="filter">List only</option>
      </select>
      <label>Transferred, Completed</label>
      <select
        v-model="filters.transferred_completed"
        @change="checkFilters('transferred_completed')"
      >
        <option value="include">Include in list</option>
        <option value="exclude">Exclude from list</option>
        <option value="filter">List only</option>
      </select>
      <label>In Process</label>
      <select v-model="filters.in_process" @change="checkFilters('in_process')">
        <option value="include">Include in list</option>
        <option value="exclude">Exclude from list</option>
        <option value="filter">List only</option>
      </select>
      <div class="divider"></div>
      <div class="title">Filter on Date...</div>
      <select v-model="filters.which_date">
        <option value="transfer_date">Transfer Date</option>
        <option value="date_created">Date Created</option>
      </select>
      <div class="label-group">
        <label>Start</label>
        <input
          type="date"
          v-model="filters.start_date"
          :max="$today().clone().format('YYYY-MM-DD')"
        />
      </div>
      <div class="label-group">
        <label>End</label>
        <input
          type="date"
          v-model="filters.end_date"
          :max="$today().clone().format('YYYY-MM-DD')"
        />
      </div>
      <div class="label-group">
        <label></label>
        <div class="button small neutral" @click="setFilterDates()">
          Filter Dates
        </div>
      </div>
      <div class="divider"></div>
      <label>Include...</label>
      <ul class="checkbox-group">
        <li>
          <span
            :class="[
              'pointer',
              'far',
              filters.include_canceled ? 'fa-check-square' : 'fa-square',
            ]"
            @click="toggleFilter('include_canceled')"
          ></span>
          <label>Canceled Forms</label>
        </li>
        <li>
          <span
            :class="[
              'pointer',
              'far',
              filters.include_moved ? 'fa-check-square' : 'fa-square',
            ]"
            @click="toggleFilter('include_moved')"
          ></span>
          <label>Originals of Corrected Forms</label>
        </li>
      </ul>
      <div class="divider"></div>
      <div
        :class="['button', hasFilters() ? 'neutral' : 'disabled']"
        @click="clearFilters()"
      >
        Reset Filters
      </div>
      <div class="divider"></div>

      <div v-if="notOnLatestFFLNumber">
        <div class="button disabled">
          Start a new form
        </div>
        <label>Starting a new 4473 under a previous FFL Number is not allowed.</label>
      </div>
      <div v-else class="button primary action" @click="startNewForm = true">
        Start a new form
      </div>

      <div class="divider"></div>
      <div
        @click="toggleFilter('bookmarked')"
        class="extra-menu-item with-icon"
      >
        <i class="fas fa-bookmark" /><span
          >Bookmarked Forms
          <i class="fas fa-check" v-if="filters.bookmarked"></i
        ></span>
      </div>
      <div
        v-if="clientHasVariance"
        @click="toggleFilter('pdf_required')"
        class="extra-menu-item with-icon"
      >
        <i class="fas fa-save" /><span
          >PDF Not Generated
          <i class="fas fa-check" v-if="filters.pdf_required"></i
        ></span>
      </div>
      <div
        v-if="clientHasVariance"
        @click="toggleFilter('internal_use_only')"
        class="extra-menu-item with-icon"
      >
        <i class="fas fa-edit" /><span
          >Marked for Correction
          <i class="fas fa-check" v-if="filters.internal_use_only"></i
        ></span>
      </div>
      <div
        @click="toggleFilter('disqualified')"
        class="extra-menu-item with-icon"
      >
        <i class="fas fa-bell" /><span
          >Customer Disqualified
          <i class="fas fa-check" v-if="filters.disqualified"></i
        ></span>
      </div>
      <div class="divider"></div>
      <div
        class="extra-menu-item"
        @click="
          attachmentIssues = [];
          showDownlaodForms = true;
        "
      >
        Download Forms
      </div>
      <a
        class="extra-menu-item"
        href="/dashboard/logbooks/customer-4473"
        target="_blank"
        >Customer Kiosk</a
      >
      <div class="divider"></div>
      <router-link to="/logbooks/uploaded-paper-forms" class="extra-menu-item">
        Uploaded Paper Forms
      </router-link>

      <div v-if="!clientHasVariance">
        <div class="divider"></div>
        <router-link to="/logbooks/enable-feature?paperless=1" class="label">
          The ATF now allows paperless storage without a specific variance.<br />
          Enable paperless storage here...
        </router-link>
      </div>

      <div class="divider"></div>
      <div class="title pointer" @click="showListLegend = !showListLegend">
        List Legend
        <i
          class="fas fa-caret-right"
          :class="showListLegend ? 'caret_rotate' : 'normal_caret'"
        ></i
        ><br />
        <label class="pointer"
          >Click to {{ showListLegend ? "hide" : "show" }} the legend /
          additional filters</label
        >
      </div>
      <div v-if="showListLegend" class="legend">
        <div
          @click="toggleFilter('section_completed', 'A')"
          class="status-filter"
        >
          <div class="status-filter-icon start-section-b"></div>
          <span>Start Section B</span
          ><i class="fas fa-check" v-if="filters.section_completed == 'A'"></i>
        </div>
        <div
          @click="toggleFilter('section_completed', 'B')"
          class="status-filter"
        >
          <div class="status-filter-icon start-nics-check"></div>
          <span>Start NICS Check</span
          ><i class="fas fa-check" v-if="filters.section_completed == 'B'"></i>
        </div>
        <div
          @click="toggleFilter('section_completed', 'E,F')"
          class="status-filter"
        >
          <div class="status-filter-icon complete"></div>
          <span>Section E Complete</span
          ><i
            class="fas fa-check"
            v-if="filters.section_completed == 'E,F'"
          ></i>
        </div>
        <div @click="toggleFilter('internal_use_only')" class="status-filter">
          <div class="status-filter-icon awaiting-correction"></div>
          <span>Awaiting Correction</span
          ><i class="fas fa-check" v-if="filters.internal_use_only"></i>
        </div>
        <div @click="toggleFilter('inactive', 1)" class="status-filter">
          <div class="status-filter-icon canceled"></div>
          <span>Form Canceled</span
          ><i class="fas fa-check" v-if="filters.inactive"></i>
        </div>
        <div @click="toggleFilter('disqualified', 1)" class="status-filter">
          <div class="status-filter-icon disqualified"></div>
          <span>Customer Disqualified</span
          ><i class="fas fa-check" v-if="filters.disqualified"></i>
        </div>
        <div class="filter-spacer"></div>
        <div
          @click="toggleFilter('status', 'nics_proceed')"
          class="status-filter"
        >
          <div class="status-filter-icon nics-proceed"></div>
          <span>NICS Proceed</span
          ><i class="fas fa-check" v-if="filters.status == 'nics_proceed'"></i>
        </div>
        <div
          @click="toggleFilter('status', 'nics_delayed')"
          class="status-filter"
        >
          <div class="status-filter-icon nics-delayed"></div>
          <span>NICS Delayed</span
          ><i class="fas fa-check" v-if="filters.status == 'nics_delayed'"></i>
        </div>
        <div
          @click="toggleFilter('status', 'nics_denied')"
          class="status-filter"
        >
          <div class="status-filter-icon nics-denied"></div>
          <span>NICS Denied</span
          ><i class="fas fa-check" v-if="filters.status == 'nics_denied'"></i>
        </div>
        <div
          @click="toggleFilter('status', 'nics_canceled')"
          class="status-filter"
        >
          <div class="status-filter-icon nics-canceled"></div>
          <span>NICS Canceled</span
          ><i
            class="fas fa-check"
            v-if="filters.status == 'nics_canceled'"
          ></i>
        </div>
        <div
          @click="toggleFilter('status', 'nics_overturned')"
          class="status-filter"
        >
          <div class="status-filter-icon nics-overturned"></div>
          <span>NICS Overturned</span
          ><i
            class="fas fa-check"
            v-if="filters.status == 'nics_overturned'"
          ></i>
        </div>
        <div
          @click="toggleFilter('status', 'nics_no_response')"
          class="status-filter"
        >
          <div class="status-filter-icon nics-no-response"></div>
          <span>NICS No Response</span
          ><i
            class="fas fa-check"
            v-if="filters.status == 'nics_no_response'"
          ></i>
        </div>
        <div
          @click="toggleFilter('status', 'nics_buyer_exempt')"
          class="status-filter"
        >
          <div class="status-filter-icon nics-buyer-exempt"></div>
          <span>NICS Buyer Exempt</span
          ><i
            class="fas fa-check"
            v-if="filters.status == 'nics_buyer_exempt'"
          ></i>
        </div>
      </div>
    </div>

    <!-- <loading class="list logbook-entries" v-if="loading"></loading> -->

    <div class="list report-list" v-if="!loading && logBookForms.length > 0">
      <table class="logbook-forms data-list" cellpadding="0" cellspacing="0">
        <thead>
          <tr>
            <th></th>
            <th>Date Created</th>
            <th>Name / Address</th>
            <th>Transfer Date</th>
            <th>Transaction SN</th>
            <th v-if="filters.include_moved" class="center">Corrected</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr
            class="list clickable-list-item"
            v-for="(item, index) in logBookForms"
          >
            <td class="status-cell" :class="statusClass(item)">
              <div class="status-expanded">
                <span class="status">{{ itemLegendLabel(item) }}</span>
                <span v-if="proceedDate(item)" class="status">{{
                  proceedDate(item).format("MM-DD-YYYY")
                }}</span>
              </div>
            </td>
            <td @click="goToDetail(item)">
              {{ $moment(item.date_created).format("MM/DD/YYYY") }}
            </td>
            <td @click="goToDetail(item)">
              {{ item.contact_data.full_name }}<br />{{
                item.contact_data.address_1
              }}
              {{ item.contact_data.city }} {{ item.contact_data.state }}
              {{ item.contact_data.zip_code }}
            </td>
            <td @click="goToDetail(item)">
              {{
                item.transfer_date
                  ? $moment(item.transfer_date).format("MM/DD/YYYY")
                  : ""
              }}
            </td>
            <td @click="goToDetail(item)">{{ item.form_number }}</td>
            <td
              v-if="filters.include_moved"
              class="center"
              @click="goToDetail(item)"
            >
              <i
                v-if="item.moved_to_ffl_log_book_form_id"
                class="fa fa-check"
              ></i>
            </td>
            <td class="links">
              <a
                class="link"
                :href="generatePDFLink(item.ffl_log_book_form_id, item.version)"
                target="_blank"
                ><i class="far fa-file" title="Generate PDF"></i
              ></a>
              <span class="link" @click="bookmarkForm(item)"
                ><i
                  :class="[item.bookmarked ? 'fas' : 'far', 'fa-bookmark']"
                  :title="'Bookmarked ' + item.bookmarked"
                ></i
              ></span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="empty-list" v-else-if="logBookForms.length == 0 && !loading">
      No forms found
    </div>

    <div class="modal" v-if="showModal">
      <div class="inner">
        <h2>{{ $caplitalizeWords(modalFor) }}</h2>
        <div class="content">
          <div v-html="modalContent"></div>
        </div>
        <div class="controls">
          <div class="button cancel" @click="showModal = false">Cancel</div>
        </div>
      </div>
    </div>

    <div v-if="startNewForm" v-show="!showSelectedContact" class="modal">
      <div class="inner">
        <h2>New Form 4473</h2>
        <div class="content">
          <p>
            Search your contacts and customers for the Transferee / Buyer...
          </p>
          <div class="input-with-control">
            <input
              type="search"
              v-model="contactSearchText"
              placeholder="Search contacts..."
              @search="searchContacts()"
            />
            <div class="button action input-go" @click="searchContacts()">
              <i class="fas fa-search"></i>
            </div>
          </div>
          <ul v-if="contactList.length > 0" class="search-list">
            <li
              v-for="(contact, index) in contactList"
              class="clickable-list-item"
              @click="selectContact(contact)"
              :key="index"
            >
              <span>{{ contact.full_name || $fullName(contact) }}</span>
              <span v-if="contact.address_1">, {{ contact.address_1 }}</span>
              <span v-if="contact.city"
                >, {{ contact.city }}, {{ contact.state }}
                {{ contact.zip_code }}</span
              >
              <span v-if="contact.ffl_number">, {{ contact.ffl_number }}</span>
              <span v-if="contact.activityDate"><br>
                <b>Has recent disposal or 4473 activity {{ formatRelativeDate(contact.activityDate) }} ({{ contact.activityDate.format("MM-DD-YY") }})</b>
              </span>
            </li>
          </ul>
          <div v-if="saving" style="text-align: center;" class="modal-icon">
            <i class="fa fa-spinner fa-spin" />
          </div>
          <div v-if="message">{{ message }}</div>
        </div>
        <div class="controls">
          <div
            class="button cancel spaced"
            @click="
              contactSearchText = '';
              contactList = [];
              startNewForm = false;
            "
          >
            Cancel
          </div>
          <div class="button neutral spaced" @click="showNewContact = true">
            New Contact
          </div>
        </div>
      </div>
    </div>

    <div v-if="showNewContact" class="modal">
      <div class="inner">
        <h2>{{ newContact.contact_id ? "Update" : "New" }} Contact</h2>
        <div class="content">
          <div class="four-columns">
            <label>First Name</label>
            <label>Middle Name</label>
            <label>Last Name</label>
            <label>Suffix</label>
            <input type="text" v-model="newContact.first_name" />
            <input type="text" v-model="newContact.middle_name" />
            <input type="text" v-model="newContact.last_name" />
            <input type="text" v-model="newContact.suffix" />
          </div>
          <label>Company Name</label>
          <input type="text" v-model="newContact.company_name" />
          <div v-if="message" class="message center">{{ message }}</div>
          <div class="two-columns">
            <div>
              <label>Phone Number</label>
              <input type="text" v-model="newContact.phone_number" />
            </div>
            <div>
              <label>Email Address</label>
              <input type="text" v-model="newContact.email_address" />
            </div>
          </div>
          <div class="note">
            Your customer's phone number or email address allows you to contact
            them<br />if the background check response is not immediately
            available.
          </div>
        </div>
        <div class="controls">
          <div class="button cancel spaced" @click="showNewContact = false">
            Cancel
          </div>
          <div class="button action spaced" @click="saveNewContact()">
            Save Contact
          </div>
        </div>
      </div>
    </div>

    <div v-if="showSelectedContact" class="modal">
      <div class="inner">
        <h2>CONFIRM CUSTOMER</h2>
        <div class="content" style="text-align: center; font-weight: bold; color: red">
          <p style="font-size: 2em;" v-if="selectedContact.full_name">{{ selectedContact.full_name || $fullName(selectedContact) }}</p>
          <p v-if="selectedContact.address_1">{{ selectedContact.address_1 }}</p>
          <p v-if="selectedContact.city">{{ selectedContact.city }}, {{ selectedContact.state }} {{ selectedContact.zip_code }}</p>
          <p v-if="selectedContact.ffl_number">{{ selectedContact.ffl_number }}</p>
        </div>
        <div class="controls">
          <div class="button cancel spaced" @click="selectContact()">
            Cancel
          </div>
          <div class="button action spaced" @click="assignContactToNewForm(selectedContact)">
            Confirm
          </div>
        </div>
      </div>
    </div>

    <div
      v-if="showDownlaodForms"
      :class="['modal', { 'medium-modal': attachmentIssues.length > 0 }]"
    >
      <div class="inner">
        <h2>Download Forms</h2>
        <div class="content">
          <div
            v-if="downloadMessage"
            :style="
              'min-height: ' + (attachmentIssues.length > 0 ? '14em;' : '5em')
            "
          >
            <p>{{ downloadMessage }}</p>
            <p v-if="saving" class="center">
              <i class="fa fa-spinner fa-spin"></i>
            </p>
            <p v-for="(issue, index) in attachmentIssues" :key="index">
              Form ID {{ issue.form_id }}, {{ issue.customer }}<br />
              {{ issue.file_name }}, {{ issue.message }}
            </p>
          </div>
          <div v-else class="two-columns">
            <div>
              You can download all forms created or updated in a given date
              range. Forms will be PDFs saved in a .zip file for faster download
              and easier storage on your computer.
            </div>
            <div class="one-two-columns align-center">
              <label>Start Date</label>
              <input type="date" :max="today" v-model="archiveDateStart" />
              <label>End Date</label>
              <input type="date" :max="today" v-model="archiveDateEnd" />
            </div>
          </div>
        </div>
        <div class="controls">
          <div
            v-if="!saving"
            class="button cancel spaced"
            @click="cancelDownloadArchive()"
          >
            Cancel
          </div>
          <div
            v-if="attachmentIssues.length == 0"
            :class="[
              'button',
              archiveDateStart && archiveDateEnd && !saving
                ? 'action'
                : 'disabled',
              'spaced',
            ]"
            @click="downloadArchive()"
          >
            Download Forms
          </div>
          <div
            v-if="downloadAlert"
            class="message"
            v-html="downloadAlert"
          ></div>
        </div>
      </div>
    </div>

    <div v-if="showRouteFirstRequested" class="modal">
      <div class="inner">
        <h2><i class="fa fa-bell" style="float: left" /> New Program</h2>
        <div class="content">
          <p>
            Welcome to the new 4473 program! There are several features here
            that we think will make your compliance tasks simpler...
          </p>
          <ul>
            <li>
              All new forms you start will use the ATF's latest form OMB No.
              1140-0020.
            </li>
            <li>
              You can still view and manage your existing OMB No. 1140-0003
              forms.
            </li>
            <li>
              The redesigned Customer Kiosk makes it easier to identify customer
              forms.
            </li>
            <li>
              You can now download all forms for a given day with a single
              click.
            </li>
          </ul>
        </div>
        <div class="controls">
          <div class="button action" @click="showRouteFirstRequested = false">
            Got It!
          </div>
        </div>
      </div>
    </div>

    <message-modal
      v-if="message"
      :message="message"
      :loading="loading"
      :errorStatus="messageStatus"
      :timeout="messageTimeout"
      @dismiss="message = ''"
    />

    <iframe id="download" src="" style="display: none"></iframe>

    <help-popup
      :helpLink="{
        195: '4473 Management',
        196: 'Search 4473 List',
        197: 'Download / Print 4473',
        379: 'Enable Paperless 4473s',
        198: 'Begin a 4473',
      }"
      :tours="false"
    ></help-popup>
  </div>
</template>

<script>
import styles from "../detail_4473_clean.scss";
import { mapState, mapActions } from "vuex";
import HelpPopup from "@/components/HelpPopup.vue";

export default {
  name: "form4473-list",
  components: {
    "help-popup": HelpPopup,
  },
  data() {
    return {
      client_id: null,
      recentActivities: [],
      page: 1,
      showPagination: false,
      logBookForms: [],
      clientFFLNumbers: [],
      paging: {},
      filters: {},
      loading: false,
      message: "",
      messageStatus: "",
      messageTimeout: 0,
      checkingExtensionPresent: false,
      e4473ExtensionIDPresent: false,
      showModal: false,
      modalFor: null,
      modalContent: null,
      loadingPDF: null,
      clientHasVariance: false,
      showListLegend: false,
      token: "",
      startNewForm: false,
      showNewContact: false,
      showSelectedContact: false,
      selectedContact: {},
      contactSearchText: "",
      contactSearchMessage: "",
      contactList: [],
      newContact: {
        notes: [{ notes: "", priority: "" }],
      },
      saving: false,
      showDownlaodForms: false,
      showRouteFirstRequested: false,
      archiveDateStart: "",
      archiveDateEnd: "",
      downloadMessage: "",
      downloadAlert: "",
      attachmentIssues: [],
      default_start_date: "",
      default_end_date: "",
    };
  },
  created() {
    let theDate = new Date();
    this.today =
      theDate.getFullYear() +
      "-" +
      (theDate.getMonth() + 1).toString().padStart(2, "0") +
      "-" +
      theDate.getDate().toString().padStart(2, "0");
    this.archiveDateStart = this.today;
    this.archiveDateEnd = this.today;

    var oneMonthAgo = new Date();
    oneMonthAgo.setMonth(oneMonthAgo.getMonth() - 1);
    var ninetyDaysAgo = new Date();
    ninetyDaysAgo.setDate(ninetyDaysAgo.getDate() - 90);
    this.default_start_date = ninetyDaysAgo.toISOString().slice(0, 10);
    this.default_end_date = new Date().toISOString().slice(0, 10);

    this.fetchRouteLastRequested();
    if (sessionStorage.getItem("filters4473")) {
      this.filters = JSON.parse(sessionStorage.getItem("filters4473"));
      this.getList();
    } else {
      this.clearFilters();
    }
    // accommodate vue store latency before checking getRouteLastRequested
    setTimeout(() => {
      if (!this.getRouteLastRequested) {
        this.showRouteFirstRequested = true;
      }
    }, 1000);
  },
  mounted() {
    // this.checkExtensionPresent()
    //this.clientHasVariance = this.getElectronicStorageVariance
  },
  watch: {
    getExtensionId(newVal) {
      if (newVal) {
        this.showModal = false;
      }
    },
  },
  computed: {
    notOnLatestFFLNumber() {
      if (
        this.clientFFLNumbers.length > 0 &&
        this.filters.client_ffl_number_id !=
          this.clientFFLNumbers[0].client_ffl_number_id
      ) {
        return true;
      }
      return false;
    },
  },
  methods: {
    ...mapActions("logbooks", ["updatePreference"]),
    getList() {
      if (this.loading) {
        return;
      }
      this.loading = true;
      if (this.filters.search_in == 'serial_number' && this.filters.search_term) {
        this.message = "Searching for serial number <b>" + this.filters.search_term + "</b><br>in all stored data of your log book forms.<br><br>This may take a moment...";
      } else {
        if (this.filters.search_term) {
          this.message = "Searching for <b>" + this.filters.search_term + "</b> in your log book forms...";
        } else {
          this.filters.search_in = 'name'
          this.message = "Loading forms...";
        }
      }
      this.messageStatus = "waiting";
      this.apiCall({
        destination: "get_list_ffl_log_book_forms",
        data: this.filters,
      })
        .then((obj) => {
          this.messageStatus = obj.status;
          if (obj.status == "success") {
            this.message = "";
            this.client_id = obj.client_id;
            this.clientHasVariance = this.getElectronicStorageVariance;
            this.clientFFLNumbers = obj.client_ffl_numbers;
            if (
              this.clientFFLNumbers.length > 0 &&
              !this.filters.client_ffl_number_id
            ) {
              this.filters.client_ffl_number_id =
                this.clientFFLNumbers[0].client_ffl_number_id;
            }
            this.logBookForms = obj.log_book_forms;
            this.paging = obj.paging;
            this.showPagination = true;
            sessionStorage.setItem("filters4473", JSON.stringify(this.filters));
            this.newContact.client_id = this.client_id;
          } else {
            this.message = obj.message;
          }
          this.loading = false;
        })
        .catch((err) => {
          console.log(err);
          this.loading = false;
          this.messageStatus = 'error'
          this.message = 'Request failed. Please check your connection and try again.'
        });
    },
    doSearch() {
      this.filters.page = 1;
      this.getList();
    },
    selectContact(contact) {
      if (this.showSelectedContact) {
        this.showSelectedContact = false;
        this.selectedContact = {};
      }
      else {
        this.showSelectedContact = true;
        this.selectedContact = contact;
      }
    },
    toggleFilter(which, value) {
      if (value) {
        if (this.filters[which] == value) {
          this.filters[which] = "";
        } else {
          this.filters[which] = value;
        }
        this.filters[which == "status" ? "section_completed" : "status"] = "";
      } else if (which != "sort") {
        this.filters[which] = !this.filters[which];
      }
      this.filters.page = 1;
      this.getList();
    },
    checkFilters(which) {
      // need a slight delay for radio button to register!
      let timer = setTimeout(
        function () {
          // can only be one "filter" of these four
          if (this.filters[which] == "filter") {
            let exclusiveFilterSet = [
              "not_transferred_retention_required",
              "not_transferred_retention_not_required",
              "transferred_completed",
              "in_process",
            ];
            exclusiveFilterSet.forEach((key) => {
              if (key != which && this.filters[key] == "filter") {
                this.filters[key] = "include";
              }
            });
          }
          this.getList();
        }.bind(this),
        10
      );
    },
    setFilterDates() {
      this.filters.page = 1;
      this.getList();
    },
    generatePDFLink(formId, version) {
      let pdfLink =
        this.getPDFAPIEndpoint +
        "?action=form_4473_pdf&source=logbooks&fd_token=" +
        getCookie("dashboard_token") +
        "&form_id=" +
        this.$randomString(6) +
        formId +
        this.$randomString(6) +
        this.client_id;
      pdfLink += this.$route.query.debug ? "&debug=1" : "";
      return pdfLink;
    },
    bookmarkForm(form) {
      this.apiCall({
        destination: "save_item_ffl_log_book_form_bookmark",
        data: {
          ffl_log_book_form_id: form.ffl_log_book_form_id,
          bookmark: !form.bookmarked,
        },
      })
        .then((obj) => {
          if (obj.status == "success") {
            form.bookmarked = !form.bookmarked;
            if (this.filters.bookmarked) {
              this.getList();
            }
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    goToDetail(item) {
      if (item.version > 2) {
        this.$router.push("/logbooks/4473/" + item.ffl_log_book_form_id);
      } else if (item.date_created > "2020-09-30") {
        this.$router.push("/logbooks/4473-v2/" + item.ffl_log_book_form_id);
      } else {
        this.$router.push("/logbooks/4473/legacy/" + item.ffl_log_book_form_id);
      }
    },
    goToPage(page) {
      this.filters.page = page;
      this.getList();
    },
    hasFilters() {
      let filterIsSet = false;
      for (var property in this.filters) {
        switch (property) {
          case "page":
          case "source":
          case "shopping_cart_id":
          case "form_type":
            break;
          default:
            filterIsSet = this.filters[property] != "";
            break;
        }
        if (filterIsSet) {
          return true;
        }
      }
      return false;
    },
    clearFilters() {
      sessionStorage.removeItem("filters4473");
      let currentFilters = this.$copy(this.filters);
      let currentFFLNumberId = currentFilters.client_ffl_number_id;
      this.filters = {
        page: 1,
        search_term: "",
        sort: "date_created",
        status: "",
        form_type: "4473",
        client_ffl_number_id: currentFFLNumberId,
        section_completed: "",
        include_canceled: "",
        include_moved: "",
        disqualified: "",
        bookmarked: "",
        pdf_required: "",
        which_date: "date_created",
        start_date: this.default_start_date,
        end_date: this.default_end_date,
        not_transferred_retention_required: "include",
        not_transferred_retention_not_required: "include",
        transferred_completed: "include",
        in_process: "include",
        search_in: "name",
      };
      this.getList();
    },
    statusClass(form) {
      let className = "";
      if (form.version > 1) {
        if (form.inactive) {
          className = "canceled";
        } else if (form.internal_use_only) {
          className = "awaiting-correction";
        } else if (form.customer_disqualified) {
          className = "disqualified";
        } else if (form.section_completed == "A" && !form.status) {
          className = "start-section-b";
        } else if (
          form.section_completed == "E" &&
          form.status != "NICS_DENIED" &&
          form.status != "NICS_CANCELED"
        ) {
          className = "complete";
        } else {
          className =
            form.status.replace(/_/g, "-").toLowerCase() || "start-nics-check";
          if (form.status == "NICS_DELAYED") {
            if (this.proceedDate(form)) {
              let proceedDate = this.$moment(this.proceedDate(form));
              if (proceedDate.isSameOrAfter(this.today, "days")) {
                className = "nics-delayed";
              } else if (proceedDate.isBefore(this.today, "days")) {
                className = "nics-delayed-proceed";
              }
            }
          }
        }
      } else {
        if (form.inactive) {
          className = "canceled";
        } else if (form.internal_use_only) {
          className = "awaiting-correction";
        } else if (form.customer_disqualified) {
          className = "disqualified";
        } else if (
          form.section_completed > "D" &&
          form.status != "NICS_DENIED" &&
          form.status != "NICS_CANCELED"
        ) {
          className = "complete";
        } else {
          className =
            form.status.replace(/_/g, "-").toLowerCase() || "start-nics-check";
          if (form.status == "NICS_DELAYED") {
            if (this.proceedDate(form)) {
              let proceedDate = this.$moment(this.proceedDate(form));
              if (proceedDate.isSameOrAfter(this.today, "days")) {
                className = "nics-delayed";
              } else if (proceedDate.isBefore(this.today, "days")) {
                className = "nics-delayed-proceed";
              }
            }
          }
        }
      }
      return className;
    },
    itemLegendLabel(form) {
      let label = "";
      if (form.internal_use_only == 2) {
        label = "Awaiting Customer Correction";
      } else if (form.internal_use_only == 1) {
        label = "Awaiting Manager Correction";
      } else if (form.version > 1) {
        if (
          form.section_completed == "E" &&
          form.status != "NICS_DENIED" &&
          form.status != "NICS_CANCELED"
        ) {
          label = "E Complete";
        }
      } else {
        if (
          form.section_completed > "D" &&
          form.status != "NICS_DENIED" &&
          form.status != "NICS_CANCELED"
        ) {
          label = "E Complete";
        }
      }
      return label || this.statusClass(form).toUpperCase().replace(/-/g, " ");
    },
    proceedDate(form) {
      if (form.version == 1) {
        if (!form.form_data.section_b) return false;
        if (!form.form_data.section_b.nics_firearm_may_be_transferred)
          return false;
        return this.$moment(
          form.form_data.section_b.nics_firearm_may_be_transferred
        );
      } else {
        if (!form.form_data.section_c) return false;
        if (
          !form.form_data.section_c.nics_firearm_may_be_transferred &&
          !form.form_data.section_c.nics_additional_delay_transfer_date
        )
          return false;
        return this.$moment(
          form.form_data.section_c.nics_additional_delay_transfer_date ||
            form.form_data.section_c.nics_firearm_may_be_transferred
        );
      }
    },
    searchContacts() {
      if (!this.contactSearchText) return;
      this.message = "";
      this.contactList = [];
      this.saving = true;
      this.apiCall({
        destination: "get_list_contacts",
        data: { search_term: this.contactSearchText },
      }).then((obj) => {
        this.saving = false;
        if (obj.status == "error") {
          this.message = obj.message;
        } else if (obj.list.customers.length > 0) {
          this.contactList = obj.list.customers;
          this.getContactsRecentActivity()
        } else {
          this.message = "No matching customers found.";
        }
      }).catch((err) => {
          console.log(err);
          this.saving = false;
          this.messageStatus = 'error'
          this.message = 'Request failed. Please check your connection and try again.'
        });
    },
    getContactsRecentActivity() {
      if (this.contactList) {
        const contact_ids = this.contactList.map(contact => contact.contact_id);
        this.message = "";
        this.saving = true;
        this.apiCall({
          destination: "get_list_contacts_recent_logbook_activity",
          data: { contact_ids: contact_ids },
        }).then((obj) => {
          if (obj.status == "error") {
            this.message = obj.message;
          } else if (obj.list.length > 0) {
            this.recentActivities = obj.list;
            const recentActivitiesMap = new Map(this.recentActivities.map(activity => [activity.contact_id, activity.activity_date]));
            for (const contact of this.contactList) {
              const recentActivity = recentActivitiesMap.get(contact.contact_id);
              if (recentActivity) {
                const today = this.$moment().startOf('day');
                const activityDate = this.$moment(recentActivity).startOf('day');
                const activityDaysAgo = today.diff(activityDate, 'days');
                if (activityDaysAgo > 10) {
                  continue;
                }
                this.$set(contact, 'activityDaysAgo', activityDaysAgo);
                this.$set(contact, 'activityDate', activityDate);
              }
            }
          }
          this.saving = false;
        }).catch((err) => {
            console.log(err);
            this.saving = false;
            this.messageStatus = 'error'
            this.message = 'Request failed. Please check your connection and try again.'
          });
      }
    },
    assignContactToNewForm(contact) {
      // define data skeleton for reactivity
      let data = {
        form: {
          client_ffl_number_id: this.filters.client_ffl_number_id,
          contact_id: contact.contact_id,
          form_data: {
            section_a: {
              firearms_list: [],
            },
            section_b: {
              customer_race: { l4: "", l2: "", l6: "", l1: "", l5: "" },
              pob_code: "",
            },
            section_c: {
              customer_trans_purpose: { l1: "", l2: "", l3: "" },
            },
            section_d: {
              buyer_recertification_date: "",
            },
            section_e: {
              not_transferred: "",
            },
          },
        },
        version: "4", // all new forms are 2024+ version
      };
      this.contactList = [];
      this.saving = true;
      this.startNewForm = false;
      this.selectedContact = {};
      this.showSelectedContact = false;
      this.loading = true;
      this.message = "Generating 4473...";
      this.messageStatus = "waiting";
      this.apiCall({ destination: "save_4473", data: data }).then((obj) => {
        this.saving = false;
        if (obj.status == "success") {
          this.$router.push("/logbooks/4473/" + obj.ffl_log_book_form_id);
        } else {
          this.message = obj.message;
        }
      }).catch((err) => {
          console.log(err);
          this.loading = false;
          this.messageStatus = 'error'
          this.message = 'Request failed. Please check your connection and try again.'
        });
    },
    setNewContact(contact) {
      this.newContact = contact;
    },
    saveNewContact() {
      if (this.saving) {
        return;
      }
      this.message = "";
      if (
        (!this.newContact.first_name || !this.newContact.last_name) &&
        !this.newContact.company_name
      ) {
        this.message = "First and last name or company name are required.";
        return;
      }
      this.saving = true;
      this.apiCall({
        destination: "save_item_contact",
        data: { ...this.newContact },
      })
        .then((obj) => {
          this.saving = false;
          if (obj.status == "success") {
            this.newContact.contact_id = obj.contact_id;
            this.assignContactToNewForm(this.newContact);
          } else {
            this.message = obj.message;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    checkExtensionPresent() {
      // TODO: should this be in store.js?
      var event;
      var limit = 0;
      var interval = setInterval(() => {
        limit++;
        event = new CustomEvent("checking_extension_present");
        window.dispatchEvent(event);
        var input = document.getElementById("extension_id");
        if (input) {
          clearInterval(interval);
        } else if (limit == 60) {
          clearInterval(interval);
          this.showModal = true;
          this.modalFor = "Chrome Extension";
          this.modalContent =
            "<p>It looks like you don't have our <strong>new</strong> 4473 Chrome extension installed. To get the most out of our 4473 functionality install the <strong>new</strong> Chrome Extension for free!</p><p><strong><a href='https://chrome.google.com/webstore/detail/flight-deck-ffl-office-ni/bneeindklehjijcbhlnhdbapgfihiiid' target='_blank'>Get the extension...</a></strong></p>";
        }
      }, 1000);
    },
    downloadArchive() {
      if (this.saving) {
        return;
      }
      this.downloadAlert = "";
      if (!this.archiveDateStart || !this.archiveDateEnd) {
        return;
      }
      if (
        this.archiveDateStart < "2020-10-01" ||
        this.archiveDateEnd < "2020-10-01"
      ) {
        this.downloadAlert =
          "This function supports forms created October 1, 2020 or later.<br>Please select a different date range.<br><br>You can download older forms indivually from the detail screen.";
        return;
      }
      this.saving = true;
      this.attachmentIssues = [];
      let dateParts = this.archiveDateStart.split("-");
      let formattedDateStart =
        dateParts[1] + "/" + dateParts[2] + "/" + dateParts[0];
      dateParts = this.archiveDateEnd.split("-");
      let formattedDateEnd =
        dateParts[1] + "/" + dateParts[2] + "/" + dateParts[0];
      this.downloadMessage =
        "Getting form count for " +
        formattedDateStart +
        " - " +
        formattedDateEnd +
        "...";
      this.apiCall({
        destination: "get_item_ffl_log_book_form_count",
        data: { date: this.archiveDateStart, end: this.archiveDateEnd },
      }).then((obj) => {
        if (obj.status == "success") {
          if (obj.form_count > 0) {
            this.downloadMessage =
              "Generating PDFs for " +
              obj.form_count +
              " form" +
              (obj.form_count > 1 ? "s" : "") +
              " for " +
              formattedDateStart +
              " - " +
              formattedDateEnd +
              "...";
            // call pdf api with these dates
            let postData = {
              client_id: this.client_id,
              archive_date: this.archiveDateStart,
              archive_date_end: this.archiveDateEnd,
            };
            let pdfURL =
              this.getPDFAPIEndpoint + "?action=form_4473_pdf_date_archive";
            this.apiCall({ destination: pdfURL, data: postData }).then(
              (obj) => {
                if (obj.status == "success") {
                  this.downloadMessage =
                    "Downloading ZIP file (" + obj.archive_file_size + ")...";
                  let downloadURL = this.getPDFAPIEndpoint.replace(
                    "api.php",
                    "download.php"
                  );
                  document.getElementById("download").src =
                    downloadURL +
                    "?file_name=" +
                    obj.archive_file_path +
                    "&output_file_name=" +
                    obj.archive_file_name;
                  if (
                    obj.attachment_issues &&
                    obj.attachment_issues.length > 0
                  ) {
                    this.downloadMessage =
                      "Downloaded ZIP file (" +
                      obj.archive_file_size +
                      ") but there were attachment issues...";
                    this.saving = false;
                    this.attachmentIssues = obj.attachment_issues;
                  } else {
                    setTimeout(() => {
                      this.showDownlaodForms = false;
                      this.downloadMessage = "";
                      this.saving = false;
                    }, 3000);
                  }
                } else {
                  this.downloadMessage = obj.message;
                  this.saving = false;
                }
              }
            );
          } else {
            this.downloadMessage =
              "There are no forms for " +
              formattedDateStart +
              " - " +
              formattedDateEnd +
              ".";
            this.saving = false;
            setTimeout(() => {
              this.downloadMessage = "";
            }, 3000);
          }
        } else {
          this.downloadMessage = obj.message;
          this.saving = false;
        }
      });
    },
    cancelDownloadArchive() {
      this.saving = false;
      this.showDownlaodForms = false;
      this.downloadMessage = false;
    },
    formatRelativeDate(date) {
      const target = this.$moment(date).startOf('day');
      const today = this.$moment().startOf('day');
      const daysAgo = today.diff(target, 'days');

      if (daysAgo === 0) return 'from today';
      if (daysAgo === 1) return 'from yesterday';
      return `within the last ${daysAgo} days`;
    }
  },
};
</script>

<style lang="scss" scoped>
div.status-filter {
  cursor: pointer;
}
.legend {
  margin-bottom: 1em;
  line-height: 1.5em;
  div.status-filter-icon {
    display: inline-block;
    width: 11px;
    height: 11px;
    align-self: center;
  }
  div.status-filter {
    cursor: pointer;
    display: grid;
    grid-template-columns: 11px 11em 11px;
    grid-gap: 0.5em;
  }
  .filter-spacer {
    border-bottom: 1px dotted lightgrey;
    width: 100%;
  }
}
.logbook-forms {
  td:first-child {
    padding: 0;
  }
  th:nth-child(2),
  td:nth-child(2) {
    padding-left: 0.5em;
  }
  td.links {
    min-width: 2em;
    text-align: right;
    .link {
      font-size: 1.25em;
      display: inline-block;
      color: #ccc;
    }
    .link:last-of-type {
      padding: 0 0.5em 0 0.25em;
    }
  }
  td.links {
    width: 5em;
    padding: 0;
  }
  tr:hover {
    .link {
      color: #333;
    }
  }
}
.status-cell {
  position: relative;
  width: 1em;
}
.status-expanded {
  position: absolute;
  display: none;
  top: 0;
  min-width: 7em;
  font-size: 0.8em;
  bottom: 0;
  align-items: center;
  grid-template-columns: 1fr;
  background: inherit;
  padding: 0 0.5em;
  justify-items: center;
}
.status-cell:hover .status-expanded {
  display: grid;
}

.proceed-date {
  background: gray;
  color: white;
}
.start-section-b {
  background: lightgray;
}
.start-nics-check {
  background: gray;
}
.c-complete {
  background: lightgray;
}
.nics-pending {
  background: yellow;
  .status-expanded {
    color: white;
  }
}
.nics-denied,
.disqualified {
  background: red;
  .status-expanded {
    color: white;
  }
}
.nics-proceed {
  background: lightgreen;
  .status-expanded {
    color: white;
  }
}
.nics-delayed,
.nics-delayed-proceed,
.nics-researching {
  background: orange;
  .status-expanded {
    color: white;
  }
}
.nics-delayed-proceed {
  background: lightgreen;
  .proceed-date {
    background: green;
  }
}
.nics-canceled {
  background: black;
  .status-expanded {
    color: white;
  }
}
.nics-no-response {
  background: yellow;
  .status-expanded {
    color: black;
  }
}
.nics-overturned {
  background: blue;
  .status-expanded {
    color: white;
  }
}
.nics-buyer-exempt {
  background: lightgreen;
  .status-expanded {
    color: white;
  }
}
.canceled {
  background: red;
  .status-expanded {
    color: white;
  }
}
.complete {
  background: green;
  .status-expanded {
    color: white;
  }
}
.awaiting-correction {
  background: #4bbdad;
  .status-expanded {
    color: white;
  }
}
</style>
